
import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
let strCust=[{title:'',year:0}];
const headCells = [
{ id: 'fbcreateddate', numeric: false, label: 'Date' },
	{ id: 'fb_course', numeric: false, label: 'Course Rating' },
	{ id: 'fb_staff', numeric: false, label: 'Yoga trainer Rating' },
	{ id: 'fb_experience', numeric: false, label: 'Exp Rating' },
	{ id: 'fb_trainers', numeric: false, label: 'Training Rating' },
{ id: 'fb_message', numeric: false, label: 'Feedback' },
 { id: 'st_name', numeric: false, label: 'Yoga Trainer' },
  { id: 'sb_title', numeric: false, label: 'Duration' },
  { id: 'type', numeric: false, label: 'Class Type' },
  
   { id: '', numeric: false, label: 'Submitted by' },   
 ]

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});




export default class AdminFeedback extends Component {
	
    constructor(props) {
    super(props);
   
     this.state = {redirect: false,fbid:'',sb_type:0,fb_experience:0,fb_trainers:0,fb_message:'',custarray:[],cu_name:'',selectedcustomerexchange:[],customerrauto:[],custid:'',
     feedbackdata:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],rolelabel:'Select Yoga Trainer',staff:'',staffarray:[],subscribeData:[],subid:'',
	 
	  order:'desc' ,orderBy:'',
	          
      }
	   this.onTagscustomerexchange = this.onTagscustomerexchange.bind(this);
	 
	}
	  

/*updateDonenewParent = (text) => {  this.apicall(this.state.page,this.state.rowsPerPage); }

*/
	


handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  	 myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 

  this.setState({[nam]: val});
  
}

   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };  

componentWillMount  () {
	

	
	document.title = "AthaYog Living - Feedback";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }

	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
   this.onloadStaffbind();
}

apicall(page,rowsPerPage){
	
 axios.get(Serverurl+'ajaxfeedback.php?action=getall&StartIndex='+page+'&PageSize='+rowsPerPage+'&fb_classtype='+this.state.sb_type+'&userid='+this.state.custid+'&fb_st_id='+this.state.staff+'&fb_sb_id='+this.state.subid)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  feedbackdata:resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
		
			
	  
	
	 
     }
	 else{
		   this.setState({feedbackdata:[],totaldata:0});
	 }
 
    });
}




onloadCustomerexchangeBind=(event)=>{
		 
		 if(event.target.value.length>2 ){
			axios.get(Serverurl+'ajaxcustomer.php?action=autoextender&cu_name='+event.target.value)
  .then(resp => { 
  this.setState({ custarray:resp.data});

	 var rowsArray = this.state.custarray;
	 rowsArray.map((row, i) => {
			 
		 const items = {
        title:row.title,
          year:row.year,
         
			   
        };
          strCust.push(items);
		  
		 });
		 this.setState({customerrauto:strCust})
  }); 
		 }
	 }

 onTagscustomerexchange = (event, values) => {
		
		   if(values!==" " && values!==null){
			  
		  this.setState({ custid:values.year,selectedcustomerexchange:values},()=>{})
		   }else{
			   this.setState({ custid:'',selectedcustomerexchange:[]})
		   }
	 }
 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
 
 
	  
 
	  
	    feedbackEdit(val){
        this.setState({ fbid: val },()=>{this.refs.Feedbackbox.handleClickOpen()});  
        }

onloadsubscribeBind(){
  axios.post(Serverurl+'ajaxsubscription.php?action=getall&sb_type=1,2,3,4,6&sorting=sb_type')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						subscribeData:resp.data	
							},()=>{
								
								
								 let subscribeFromApi = this.state.subscribeData.map(row => {
                          
          return {value:row.sb_id,display:row.sb_title,label:row.type,type:row.sb_type}
						 
        });
      
	
        this.setState({
          subscribeData: [{value: '', display:'Select Duration',label:'',type:'0'}].concat(subscribeFromApi)
        },()=>{});
								
							})
	
														
			}else{
				this.setState({subscribeData:[]});
			}
 
    });

}
onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3')
	
    
      .then((response) => {    
     
      this.setState({  staffarray: response.data,  },()=>{
		  
		  let roleFromApi = this.state.staffarray.map(st => {
                            
          return {value: st.st_id, display:st.st_name}
        });
      
        this.setState({
          staffarray: [{value: '', display: 'All'}].concat(roleFromApi)
        });
		  
		  
	  });
	  
	  this.onloadsubscribeBind();
      })   
    
    
} 
handleClickSearch=()=>{   
   
  this.apicall(this.state.page,this.state.rowsPerPage); 
	
} 
 onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({sb_type: event.target.value},()=>{ this.onloadsubscribeBind();});
	}
render() {
	 let prev="";
	
	if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return(
 
 




 
 
 
 <React.Fragment>
 
  <div className="mainheading"><h1> Reviews</h1></div>

<div className="clear"></div>

	
	
<Feedbackbox ref="Feedbackbox" fbid={this.state.fbid}  updateDonenew={this.updateDonenewParent}/>

 <div className="searchmaster">
 <ul>
  
 <li><p>Yoga Trainer</p>
 
 <p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.staff }}
          onChange={this.myChangeHandler}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p></li>
				
				<li><p>Customer Name</p>			
<p>

<Autocomplete
      id="free-solo-demo"
      
      className="txtbox"  name="custid" value={this.state.custid}
      options={this.state.customerrauto}  
	   onChange={this.onTagscustomerexchange} 
	    value={this.state.selectedcustomerexchange}
      renderInput={(params) => (
        <TextField {...params} className="txtbox" onChange={this.onloadCustomerexchangeBind}  variant="outlined" />
      )}
 getOptionLabel={(option) => option.title || ""}

      
    />
</p>
	</li>
					  
<li>  
		  <p><span className="validation">*</span>Class Type</p>
		 
		<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined" className="txtbox"
          margin="normal"
          onChange={this.onChangeClass}
          id="sb_type"
		   value={this.state.sb_type}
		  name="sb_type"
		inputProps={{tabIndex: "4"}}
        >
	<option value={0}>Select Type</option>
	<option value={1}>Personal Training at Home</option>
	<option value={2}>Personal Training in studio</option>	
	<option value={3}>Group Session</option>	
	<option value={4}>Prenatal</option>	
	<option value={6}>Personal Training Online</option>	
        </Select>

		</FormControl>
		</p>
 
 </li>		
			<li><p>Duration</p>
 
 <p><FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native 	inputProps={{tabIndex: "3"}}
			value={this.state.subid}
			onChange={this.myChangeHandler}
			name='subid'
			
			fullwidth
			
			
			>
		
		
			{this.state.subscribeData.map((row,index) =>{
	
	
		this.state.subscribeData.filter(options => options.type == row.type);
	
	if(prev!=row.type)
	{
	prev=row.type
				return(
				 <React.Fragment>
				  <optgroup label={row.label}>
				 {this.state.subscribeData.filter(options => options.type == row.type).map((sub) =>{ return(
			
				
				<option  
            
				  value={sub.value}
				>
				  {sub.display}
				</option  >
				
				)})}
		</optgroup>
	 </React.Fragment>			 
	)
	}
	
	})}
			 </Select>
		</FormControl></p></li>
		
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> &nbsp;</p></li>
		
		
		</ul>
		
</div>	
				
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.feedbackdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.feedbackdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >

<TableCell style={{"width":"20px"}}>{item.fbcreateddate}</TableCell>

<TableCell style={{"width":"20px"}}>{item.fb_course}</TableCell>
<TableCell style={{"width":"20px"}}>{item.fb_staff}</TableCell>
<TableCell style={{"width":"20px"}}>{item.fb_experience}</TableCell>
<TableCell style={{"width":"20px"}}>{item.fb_trainers}</TableCell>
<TableCell style={{"width":"350px"}}>{item.fb_message}</TableCell>
<TableCell>{item.st_name}</TableCell>
<TableCell>{item.sb_title}</TableCell>

<TableCell>{item.type}</TableCell>
<TableCell align="left" style={{"width":"250px"}}>

{item.cu_name}

 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50,100,150,200,250,300]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}    
      /> 
  </Paper>
    



 

 </React.Fragment>
 



);


		}
	
}

export  class  Feedbackbox extends Component {
	  constructor(props) {
      super(props)
	  
      this.state = {
		  
	  open:false,message:'',erropen:false,errormessage:'',alerttype:"error"}
	  
	  
	  }
	 feedbackdata() {
	
		if(this.props.fbid!==0)
		{
			axios.get(Serverurl+'ajaxfeedback.php?action=getall&fb_id='+this.props.fbid)

		  .then(resp => {  
				
			if(resp.data.length>0){
				
					this.setState({ message:resp.data[0]["fb_message"] });
			}
		  })	
		}
	 }
	 
	 handleClickOpen = (e) => {
		this.setState({open:!this.state.open, message:'', });
		this.feedbackdata();
	 }
	 
	 myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 

  this.setState({[nam]: val});
  
}

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
  
  handleClose = (e) => {
	 let message = this.state.message; 
			 if(message==="" )
		{
			
			this.setState({errormessage:"Please Enter Feedback",erropen:true});
				 window.scrollTo({
				  top: 0
			  })
				 return false;
			
			
		}
	 var formData = new FormData();
	 formData.append('action','insertorupdate') 
		formData.append('fb_id',this.props.fbid)
		formData.append('fb_message',message)
		formData.append('fb_course',0)
		formData.append('fb_staff',0)
		formData.append('fb_experience',0)
		formData.append('fb_trainers',0)
		formData.append('fb_sb_id',0)
		formData.append('fb_st_id',0)
		
			formData.append('userid',localStorage.getItem("AYLuserid"))
		axios.post(Serverurl+"ajaxfeedback.php", formData, {
        }).then(res => {this.setState({open:false});
			 this.props.updateDonenew();
		});
  }
  render (){

return(
<React.Fragment>
<Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Slot Management</DialogTitle>
      <DialogContent>
	  <p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  
	  <p>Review</p>
	  
	  <p><TextField name="message"  multiline
	   onChange={this.myChangeHandler} 
	   fullWidth 		 	 inputProps={{tabIndex: "1"}} className="txtbox" rows="3"
	   value={this.state.message}
                          /></p>
						   <div className="actionbtns">
	   <div className="cancelbtn">	  
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleClickOpen}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
   Save
</Button>
  </div>     


	
<div className="clear"></div>  </div>   
	   </DialogContent>
	   
	   </Dialog>
</React.Fragment>

)
  }
}